import React from "react";
import styles from "../teams/components/TeamSettings.module.css";

/** Subline under caps badge: either stable, or "from" + a prior level (never the same word as the badge). */
export type DemoPattern =
  | { kind: "stable" }
  | { kind: "from"; priorLabel: string };

/** One row per team; `status` drives caps label + badge color; `pattern` is second line. */
export const DEMO_TEAMS = [
  {
    name: "Engineering",
    status: "recharging" as const,
    pattern: { kind: "from", priorLabel: "Challenged" } satisfies DemoPattern,
  },
  {
    name: "Transport",
    status: "balanced" as const,
    pattern: { kind: "stable" } satisfies DemoPattern,
  },
  {
    name: "Business",
    status: "challenged" as const,
    pattern: { kind: "from", priorLabel: "Charging" } satisfies DemoPattern,
  },
  {
    name: "Support",
    status: "overwhelmed" as const,
    pattern: { kind: "from", priorLabel: "Balanced" } satisfies DemoPattern,
  },
];

export type DemoTeamStatus = (typeof DEMO_TEAMS)[number]["status"];

export const DEMO_STATUS_CAPS: Record<DemoTeamStatus, string> = {
  recharging: "RECHARGING",
  balanced: "BALANCED",
  challenged: "CHALLENGED",
  overwhelmed: "OVERWHELMED",
};

export function TeamDemoPatternSubline({ pattern }: { pattern: DemoPattern }) {
  if (pattern.kind === "stable") {
    return (
      <span className={styles["team-demo-card-pattern"]}>
        <span className={styles["team-demo-card-pattern-stable-lead"]}>
          Stable
        </span>
        <span className={styles["team-demo-card-pattern-stable-tail"]}>
          {" "}
          pattern
        </span>
      </span>
    );
  }
  return (
    <span className={styles["team-demo-card-pattern"]}>
      <span className={styles["team-demo-card-pattern-from"]}>from </span>
      <span className={styles["team-demo-card-pattern-emphasis"]}>
        {pattern.priorLabel}
      </span>
    </span>
  );
}

export function getDemoTeamByName(name: string | null | undefined) {
  if (!name) return undefined;
  const trimmed = name.trim();
  return DEMO_TEAMS.find((t) => t.name === trimmed);
}
